import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'mark-ignored-dialog',
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props
const emit = __emit

const visible = computed({
  get: () => props.modelValue,
  set: (v) => emit('update:modelValue', v),
})

function onConfirm () {
  emit('confirm')
  visible.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    title: _ctx.$t('securityEvent.markIgnoredTitle'),
    width: "480px",
    "destroy-on-close": "",
    onClose: _cache[2] || (_cache[2] = ($event: any) => (visible.value = false))
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (visible.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_el_button, {
        type: "primary",
        size: "small",
        onClick: onConfirm
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.confirm')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.$t('securityEvent.markIgnoredConfirm')), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})